import { createContext } from 'react';
import { FlashMessageContext } from './types';

export default createContext<FlashMessageContext>({
  messages: [],
  createMessage: (message) => {},
  removeMessage: (id) => {},
});
